const addProj = () => import(/* webpackChunkName: "herb" */ './addProj');
const indexApp = () => import('./indexAppl.vue');
const indexAdmin = () => import('./indexAdmin');
const indusEdit = () => import('./indusEdit');

//2023项目储备库管理
export default {
  routes: [
    {
      path: '/projlib/v2025/indexApp',
      name: 'proj_lib_v2025_index_App',
      component: indexApp,
      meta: {public: true}
    },
    {
      path: '/projlib/v2025/indexAdmin',
      name: 'proj_lib_v2025_index_Admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/projlib/v2025/addProj',
      name: 'proj_lib_v2025_add_proj',
      component: addProj,
      meta: {public: true}
    },
    {
      path: '/projlib/v2025/indusEdit',
      name: 'proj_lib_v2025_indus_edit',
      component: indusEdit,
      meta: {public: true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/projLib/V2025/router.js